import { useState, useCallback, useRef } from 'react';

export const useMenuVisible = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const dismissMenu = useCallback(() => {
    timeoutRef.current = setTimeout(() => {
      setIsMenuOpen(false);
    }, 350);
  }, []);

  const openMenu = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsMenuOpen(true);
  }, []);

  return { isMenuOpen, dismissMenu, openMenu };
};
